import { SnowplowTrigger } from 'Snowplow'
import clickEventName from 'utils/DOM/clickEventName'
import { registerSnowplowTriggers } from 'utils/snowplow/events/userClick/registerSnowplowTriggers'
import { buildSpValueToString } from 'utils/snowplow/utils/buildSpValueToString'

const compareTriggers: SnowplowTrigger[] = [
  {
    element: '.compare-header__select-plan',
    description: 'Compare - select plan',
    elementTrigger: clickEventName,
    eventType: 'click',
    placement: 'compare-header'
  },
  {
    element: '.compare-footer__download-brochure, .dropdown-item',
    description: 'Compare - download brochure',
    elementTrigger: clickEventName,
    eventType: 'click',
    placement: 'compare-footer',
    valueParser: () => 'Download brochure'
  },
  {
    element: '.compare-footer__see-plan-details',
    description: 'Compare - see plan details',
    elementTrigger: clickEventName,
    eventType: 'click',
    placement: 'compare-footer'
  },
  {
    element: '#compare-controls__action__diff',
    description: 'Compare - show differences',
    elementTrigger: clickEventName,
    eventType: 'click',
    placement: 'compare-controls',
    valueParser: () => 'See plan differences'
  }
]

export function parsePlanSpValue(planRawData) {
  return buildSpValueToString(planRawData, plan => ({
    planId: plan.planId,
    planName: plan.planName,
    duration: plan.period
  }))
}

export default function registerAgentSnowplowListeners() {
  registerSnowplowTriggers(compareTriggers)
}
